import React, { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom';
import Utils from './utils';



const Provider = ({ children }) => {
    const userRoutes = JSON.parse(Utils.getLocalStorageItem('accessMenus') || '{}');

    const location = useLocation();
    const navigate = useNavigate();

    const sanitizedPath = location?.pathname?.replace(/\/[a-f0-9\-]{36}$/, '');

    const isPathIncluded = userRoutes?.path?.some((route) => {
        const regex = new RegExp(`^${route.replace(/:\w+/g, '[^/]+')}$`);
        return regex.test(sanitizedPath);
    });


    useEffect(() => {
        if (!isPathIncluded) {
            console.log("Path names did not match. Redirecting...");
            navigate("/unauthorized");
        }
    }, [isPathIncluded, navigate]);


    return isPathIncluded ? children : null;
};

export default Provider;
